import React from 'react'
import { Box } from '@fedsim/components'
import { useNavigate } from 'react-router-dom'

import TopFiles from './files';
import Logo from 'components/fsx-logo'
import Drawer from './drawer'
import { trackEv, Categories, Actions } from 'analytics'

const LOCATION = '/office';

export default function Topbar() {
  const navigate = useNavigate()
  const onGoOffice = () => {
    trackEv(Categories.Topbar, Actions.Navigate, { label: "LOGO" })

    navigate(LOCATION)
  }
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        paddingY: '10px',
        justifyContent: "space-between",
        background: "transparent",
        backgroundColor: "#000",
        backgroundImage: 'radial-gradient(rgba(255,255, 255, 0.4) 0.5px, transparent 0.5px)',
        backgroundSize: '25px 25px',
        padding: {
          xs: "4px 18px",
          sm: "4px 18px",
          md: "4px 18px",
          lg: "8px 24px"
        }
      }}
    >
      <span onClick={onGoOffice}><Logo variant={2} /></span>
      <TopFiles />
      <Drawer />
    </Box>
  )
}
